
import Vue from 'vue';
import { mapGetters } from 'vuex';

import { Marche } from '@/model/marche';
import { CodeCoursMarche } from '@/model/enum-types/code-cours-marche';
import variation from './variation.vue';

export default Vue.extend({
  components: { variation },
  name: 'InformationsMarche',
  data: () => ({
    messageOverflow: false,
    dialog: false
  }),
  computed: {
    ...mapGetters({
      informationsMarche: 'referentiel/informationsMarche',
      marches: 'cours-marche/marches'
    }),
    canBeShowed (): boolean {
      return this.isMobile ? (this.informationsMarche && this.informationsMarche.texte !== '') || (this.pariteEuroDollars !== null && this.gazNaturel !== null) : true;
    },
    pariteEuroDollars (): number {
      return (this.marches as Marche[]).find(m => m.code === CodeCoursMarche.PARITE_EUR_USD).valeurs[0].valeur;
    },
    gazNaturel (): number {
      return (this.marches as Marche[]).find(m => m.code === CodeCoursMarche.GAZ_NATUREL).valeurs[0].valeur;
    }
  },
  mounted () {
    if (this.isOverflown(this.$refs.message as Element)) {
      this.messageOverflow = true;
    }
  },
  methods: {
    isOverflown (element: Element): boolean {
      if (!element) {
        return false;
      }
      return element.scrollHeight > element.clientHeight;// || element.scrollWidth > element.clientWidth;
    },
    getVariation (codeMarche: CodeCoursMarche): number {
      const marche = (this.marches as Marche[]).find(m => m.code === codeMarche);
      return marche.valeurs.length >= 2 ? marche.valeurs[1].valeur - marche.valeurs[0].valeur : 0;
    },
    open () {
      this.$dialog.confirm({
        icon: 'mdi-help-circle-outline',
        // title: this.title,
        text: this.informationsMarche.texte,
        width: 900,
        actions: {
          false: {
            text: 'Fermer',
            flat: false,
            outlined: true,
            color: 'grey'
          }
        }
      });
    }
  }
});
